import { Delete } from '@mui/icons-material';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
var DiscardInvoicePopup = function (props) {
    var navigate = useNavigate();
    var onClose = props.onClose;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            gap: '16px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Icon,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(Delete, null),
                            columnSize: 0,
                            sx: {
                                color: 'error.500'
                            },
                            containerProps: {
                                p: 1.5,
                                bgcolor: 'error.100',
                                height: 48,
                                borderRadius: 'full'
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Msg',
                    label: 'Are you sure you want to discard?',
                    value: null,
                    columnSize: 12,
                    children: "Your changes will be lost if you discard them. This action cannot be undone.",
                    labelTypographyProps: {
                        fontSize: "xl",
                        fontWeight: 'strong',
                        color: 'text.primary'
                    },
                    color: 'secondary.600'
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Cancel',
                    columnSize: true,
                    fullWidth: true,
                    variant: 'outlined',
                    size: 'medium',
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Discard',
                    sx: {
                        bgcolor: "error.500"
                    },
                    columnSize: true,
                    fullWidth: true,
                    variant: 'contained',
                    size: 'medium',
                    onClick: function () {
                        navigate('/contractSaleInvoice');
                        onClose();
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    });
};
export default DiscardInvoicePopup;
